export default __webpack_public_path__ + "static/media/email-sent-animation.ea0ac50e.svg";